import { pastTense } from '@paytrace/pt-skel/Component/Helper'

export function pastTenseEx (term: string) {
  if (term === 'transaction') {
    return 'processed'
  }

  return pastTense(term)
}
